<template>
    <div class="health-page">
        <div class="bg-yellow c-blue my-3 py-3">
            <div class="container-fluid">
                <div class="row ">
                    <div class="col">
                        <h2 class="today--heading">
                            <img class="today--heading--logo center-block" src="~__STATIC__/logo_valle_plus.svg"
                                alt="Valle plus logo">
                            <span class="title" v-text="getTranslation('healthPageTitle')"></span>
                        </h2>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-6 order-lg-2 mb-4">
                        <h2>Cuidar y cuidarnos es tarea de todos.</h2>
                        <p>Cada vez que esquíes en Valle Nevado, deberás completar este formulario con la declaración de
                            salud de manera obligatoria.
                            Una vez completado, te llegará un correo de confirmación con un código que deberás mostrar
                            al ingreso a Valle Nevado.
                            El formulario se completa de manera personal y debes hacerlo entre 72 a 24 hrs antes de tu
                            día de ski.
                            En el caso de menores de edad, debe ser completado por los padres o adulto responsable que
                            acompañe al menor.<br><br>
                            Conoce sobre nuestros <a
                                href="https://laparva.com/es/montana/protocolos_vallesafe/">protocolos LaParva Safe</a>,
                            <br>Vive Valle.</p>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <form>
                            <div class="col">
                                <div>
                                    <label class="health" for="product_type">Tipo de producto</label>
                                    <select v-model="product_type" @change="checkFilter" required>
                                        <option disabled value="">Seleccione una respuesta</option>
                                        <option value="pass_season">Pase de temporada</option>
                                        <option value="ticket_fix">Ticket con fecha</option>
                                        <option value="others">Otros tickets (Cuponeras, ski day, góndola y otros sin
                                            fecha)</option>
                                    </select>
                                </div>
                                <div class="row" v-show='toggleTicket'>
                                    <div class="col-6">
                                        <div>
                                            <label class="health" for="order_code">Ingrese identificador de pedido (N° Orden de Compra):
                                                <a href="#" data-toggle="popover" data-content='El nº de Orden de Compra lo puedes encontrar en
                                                la sección "Información" del correo.<br><br>
                                                <img class="popoverImg" src="/static/n_orden.png" />'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                </svg></a>
                                            </label>
                                            <input class="health" type="text" v-model="order_code" maxlength="100"
                                                >
                                        </div>
                                        <div>
                                            <span v-bind:class="ticketValidation"> {{ticket_message}} </span>
                                        </div>
                                        <button class="health" v-show='toggleTicket' @click="getTicketData($event)">
                                            Validar </button>
                                    </div>
                                </div>
                                <div class="row" v-show='toggleRut'>
                                    <div class="col-6">
                                        <div>
                                            <label class="health" for="pass_rut">Ingrese RUT/DNI:</label>
                                            <input class="health" type="text" placeholder="12345678-9" v-model="pass_rut" maxlength="100"
                                                >
                                        </div>
                                        <div>
                                            <span v-bind:class="passValidation"> {{rut_message}} </span>
                                        </div>
                                        <button class="health" v-show='toggleRut' @click="getPassData($event)"> Validar
                                        </button>
                                    </div>
                                    <div class="col-6">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-show='toggleForm'>
                                <div>
                                    <label class="health" for="date_attendance">Fecha de asistencia</label>
                                    <datepicker v-model="date_attendance" id="date_attendance" name="date_attendance"
                                        placeholder="Fecha de asistencia" :disabled-dates="disabledDates"></datepicker>
                                    <div>
                                        <span class="input-error"> {{msg.date_attendance}} </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div>
                                            <label class="health" for="names">Nombres:</label>
                                            <input class="health w-100" type="text" v-model="names" maxlength="100"
                                                required>
                                        </div>
                                        <div>
                                            <span class="input-error"> {{msg.names}} </span>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div>
                                            <label class="health" for="last_names">Apellidos:</label>
                                            <input class="health w-100" type="text" v-model="last_names" maxlength="100"
                                                required>
                                        </div>
                                        <div>
                                            <span class="input-error"> {{msg.last_names}} </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div>
                                            <label class="health" for="document_number">RUT/DNI:</label>
                                            <input class="health w-100" type="text" v-model="document_number" maxlength="20"
                                                 required>
                                        </div>
                                        <div>
                                            <span class="input-error"> {{msg.document_number}} </span>
                                        </div>
                                        <div>
                                            <span class="health-error-message"> {{document_number_message}} </span>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div>
                                            <label class="health" for="telephone">Teléfono:</label>
                                            <input class="health w-100" type="text" v-model="telephone" maxlength="20"
                                                 required>
                                        </div>
                                        <div>
                                            <span class="input-error"> {{msg.telephone}} </span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <label class="health" for="email">Email:</label>
                                    <input class="health w-100" type="email" v-model="email" maxlength="100"
                                        required>
                                </div>
                                <div>
                                    <span class="input-error"> {{msg.email}} </span>
                                </div>
                            </div>
                            <div class="col" v-show='toggleForm'>
                                <div>
                                    <label class="health" for="symptom_check">¿Ha presentado algún síntoma relacionado
                                        al
                                        COVID-19 en los últimos 30 días?</label>
                                    <select v-model="symptom_check" required>
                                        <option disabled value="">Seleccione una respuesta</option>
                                        <option value="false">Sí</option>
                                        <option value="true">No</option>
                                    </select>
                                    <div>
                                        <span class="input-error"> {{msg.symptom_check}} </span>
                                    </div>
                                </div>
                                <div>
                                    <label class="health" for="contact_check">¿Ha tenido contacto estrecho con alguna
                                        persona
                                        confirmada con COVID-19 en los últimos 14 días?</label>
                                    <select v-model="contact_check" required>
                                        <option disabled value="">Seleccione una respuesta</option>
                                        <option value="false">Sí</option>
                                        <option value="true">No</option>
                                    </select>
                                    <div>
                                        <span class="input-error"> {{msg.contact_check}} </span>
                                    </div>
                                </div>
                                <div>
                                    <label class="health" for="commune_check">¿Proviene de una comuna sin
                                        cuarentena?</label>
                                    <select v-model="commune_check" required>
                                        <option disabled value="">Seleccione una respuesta</option>
                                        <option value="true">Sí</option>
                                        <option value="false">No</option>
                                    </select>
                                    <div>
                                        <span class="input-error"> {{msg.commune_check}} </span>
                                    </div>
                                </div>
                                <div>
                                    <label class="health" for="attest_check">Doy fe que los datos proporcionados en este
                                        formularios son verídicos y que estoy en conocimiento de que, en caso de
                                        comprobarse
                                        falsedad en la presente declaración, quedará prohibido el acceso al
                                        establecimiento.</label>
                                    <select v-model="attest_check" required>
                                        <option disabled value="">Seleccione una respuesta</option>
                                        <option value="true">Sí</option>
                                        <option value="false">No</option>
                                    </select>
                                    <div>
                                        <span class="input-error"> {{msg.attest_check}} </span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <modal name="success-form-model" :width="300" :height="200"
                                    @before-close="beforeCloseModal">
                                    <h2 style="padding:5px;">Formulario guardado correctamente</h2>
                                    <p style="padding:10px;">Ingresa a tu email y muestra el comprobante al ingreso a Valle Nevado</p>
                                </modal>
                            </div>
                            <button v-bind:disabled="clickedSend" class="health" v-show='toggleForm' @click="sendData($event)"> Enviar datos </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import siteConfig from '../../mixins/siteConfig';
    import Datepicker from 'vuejs-datepicker';
    import API from '../../api/index';
    import axios from 'axios';

    $(function () {
        $('[data-toggle="popover"]').popover({
            html: true,
            container: 'body'
        });
    });

    export default {

        mixins: [siteConfig],
        data() {
            return {
                clickedSend: false,
                disabledDates: {},
                enabledDates: {},
                // Validations
                toggleForm: false,
                toggleRut: false,
                pass_rut: null,
                rut_message: '',
                customer: {},
                validateIsPass: false,
                // Ticket
                toggleTicket: false,
                ticket_message: '',
                order_code: '',
                // Others
                boolOtherDates: [
                    false,
                    false,
                    false
                ],
                document_number_message: '',
                // form
                msg: {
                    'names': '',
                    'last_names': '',
                    'document_number': '',
                    'telephone': '',
                    'email': '',
                    'symptom_check': '',
                    'contact_check': '',
                    'commune_check': '',
                    'attest_check': '',
                    'date_attendance': '',
                },
                product_type: null,
                names: null,
                last_names: null,
                date_attendance: null,
                document_number: null,
                telephone: null,
                email: null,
                symptom_check: null,
                contact_check: null,
                commune_check: null,
                attest_check: null,
                product_name: null,
                popoverImg: {
                    maxwidth: '80px',
                    height: 'auto'
                },
            }
        },
        components: {
            Datepicker
        },
        methods: {
            async validateForm() {
                let is_valid = true;
                if (this.date_attendance == '' || this.date_attendance == null) {
                    is_valid = false;
                    this.msg.date_attendance = 'Debe seleccionar una fecha'
                }
                if (this.names == '' || this.names == null) {
                    is_valid = false;
                    this.msg.names = 'Debe llenar el campo';
                }
                if (this.last_names == '' || this.last_names == null) {
                    is_valid = false;
                    this.msg.last_names = 'Debe llenar el campo';
                }
                if (this.document_number == '' || this.document_number == null) {
                    is_valid = false;
                    this.msg.document_number = 'Debe llenar el campo';
                } else if (this.validateIsPass){
                    let customer_rut = this.formatRut(this.document_number);
                    await this.callPassData(customer_rut).then(data => {
                        if (this.isObjectEmpty(data) === false) {
                            is_valid = false;
                            this.msg.document_number = 'El rut está registrado como cliente de pase de temporada.';
                        }
                    })
                }
                if (this.telephone == '' || this.telephone == null) {
                    is_valid = false;
                    this.msg.telephone = 'Debe llenar el campo';
                }
                if (this.email == '' || this.email == null) {
                    is_valid = false;
                    this.msg.email = 'Debe llenar el campo';
                }
                if (this.symptom_check == '' || this.symptom_check == null) {
                    is_valid = false;
                    this.msg.symptom_check = 'Debe llenar el campo';
                }
                if (this.symptom_check === 'false'){
                    is_valid = false;
                    this.msg.symptom_check = 'No se permite el ingreso al recinto a personas con síntomas de COVID-19.';
                }
                if (this.contact_check == '' || this.contact_check == null) {
                    is_valid = false;
                    this.msg.contact_check = 'Debe llenar el campo';
                }
                if (this.contact_check === 'false'){
                    is_valid = false;
                    this.msg.contact_check = 'No se permite el ingreso al recinto a personas con contacto estrecho.';
                }
                if (this.commune_check == '' || this.commune_check == null) {
                    is_valid = false;
                    this.msg.commune_check = 'Debe llenar el campo';
                }
                if (this.commune_check === 'false'){
                    is_valid = false;
                    this.msg.commune_check = 'No se permite el ingreso al recinto a personas provenientes de una comuna en cuarentena.';
                }
                if (this.attest_check == '' || this.attest_check == null) {
                    is_valid = false;
                    this.msg.attest_check = 'Debe llenar el campo';
                }
                if (this.attest_check === 'false'){
                    is_valid = false;
                    this.msg.attest_check = 'Debe estar de acuerdo con las condiciones.';
                }
                return is_valid;
            },
            resetForm() {
                this.disabledDates = {};
                this.enabledDates = {};
                // Validations
                this.toggleForm = false;
                this.toggleRut = false;
                this.pass_rut = null;
                this.rut_message = '';
                this.customer = {};
                this.validateIsPass = false;
                // Tickets
                this.toggleTicket = false;
                this.ticket_message = '';
                this.order_code = '';
                // Others
                this.boolOtherDates = [
                    false,
                    false,
                    false
                ];
                this.document_number_message = '';
                // form
                this.msg = {
                    'names': '',
                    'last_names': '',
                    'document_number': '',
                    'telephone': '',
                    'email': '',
                    'symptom_check': '',
                    'contact_check': '',
                    'commune_check': '',
                    'attest_check': ''
                };
                this.product_type = null;
                this.names = null;
                this.last_names = null;
                this.date_attendance = null;
                this.document_number = null;
                this.telephone = null;
                this.email = null;
                this.symptom_check = null;
                this.contact_check = null;
                this.commune_check = null;
                this.attest_check = null;
                this.product_name = null;
            },
            isObjectEmpty(someObject) {
                return !(Object.keys(someObject).length)
            },
            checkFilter() {
                // RESET EVERYTHING
                if (this.product_type == 'pass_season') {
                    this.resetForm();
                    this.product_type = 'pass_season';
                    this.product_name = 'PASS';
                    this.toggleRut = true;
                    this.prepareCalendar(true);
                }
                if (this.product_type == 'ticket_fix') {
                    this.resetForm();
                    this.product_type = 'ticket_fix';
                    this.product_name = 'FIX';
                    this.toggleTicket = true;
                }
                if (this.product_type == 'others') {
                    this.resetForm();
                    this.product_type = 'others';
                    this.product_name = 'OTHER';
                    this.validateIsPass = true;
                    this.getOthersData().then(data => {
                        this.prepareCalendar(false, data[0], data[1], data[2]);
                        this.toggleForm = true;
                    }).catch(error => {
                        console.log(error);
                    });
                }
            },
            sendData(e) {
                e.preventDefault();
                this.clickedSend = true;
                this.validateForm().then(
                    is_valid => {
                        if (is_valid) {
                            let customer_rut = this.formatRut(this.document_number);
                            API.health_form.post({
                                date_attendance: moment(this.date_attendance).format('YYYY-MM-DD'),
                                names: this.names,
                                last_names: this.last_names,
                                document_number: customer_rut,
                                telephone: this.telephone,
                                email: this.email,
                                symptom_check: this.symptom_check,
                                contact_check: this.contact_check,
                                commune_check: this.commune_check,
                                attest_check: this.attest_check,
                                product_name: this.product_name,
                                order_id: this.order_code
                            }).then((response) => {
                                // TODO: Show message of data received
                                this.$modal.show('success-form-model');
                                this.clickedSend = false;
                            }, (error) => {
                                // TODO: Show message of data failed
                                console.log(error);
                                this.clickedSend = false;
                            });
                        } else{
                            this.clickedSend = false;
                        }
                    }
                );
            },
            getDateTicket(order) {
                // Process date ticket and block calendar
                let fixDates = []
                order.fix_tickets.forEach(detail => {
                    // Fix: Add 1 day
                    let detail_date = new Date(detail.start_date.replace('-', '/'));
                    detail_date.setDate(detail_date.getDate() + 1)
                    fixDates.push(detail_date);
                });
                this.prepareCalendar(false, false, false, false, true, fixDates);
            },
            getTicketData(e) {
                e.preventDefault();
                if (!this.order_code) {
                    this.ticket_message = 'Debe completar este campo';
                } else {
                    this.ticket_message = '';
                    this.callTicketData(this.order_code).then(data => {
                        if (this.isObjectEmpty(data)) {
                            this.ticket_message = 'No existe orden';
                        } else {
                            if (data.is_fix_ticket) {
                                this.ticket_message = 'Orden encontrada';
                                this.names = data.customer.firstname;
                                this.last_names = data.customer.lastname;
                                this.email = data.customer.email;
                                this.getDateTicket(data);
                                this.toggleForm = true;
                            } else {
                                this.ticket_message = 'Orden sin tickets de fecha fija'
                            }
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }
            },

            formatRut(input_rut) {
                    let formatted_rut = input_rut.replace(/\./g, '').replace('-', '');

                    if (formatted_rut.match(/^(\d{2})(\d{3}){2}(\w{1})$/)) {
                        formatted_rut = formatted_rut.replace(/^(\d{2})(\d{3})(\d{3})(\w{1})$/, '$1.$2.$3-$4');
                    }
                    else if (formatted_rut.match(/^(\d)(\d{3}){2}(\w{0,1})$/)) {
                        formatted_rut = formatted_rut.replace(/^(\d)(\d{3})(\d{3})(\w{0,1})$/, '$1.$2.$3-$4');
                    }
                    else if (formatted_rut.match(/^(\d)(\d{3})(\d{0,2})$/)) {
                        formatted_rut = formatted_rut.replace(/^(\d)(\d{3})(\d{0,2})$/, '$1.$2.$3');
                    }
                    else if (formatted_rut.match(/^(\d)(\d{0,2})$/)) {
                        formatted_rut = formatted_rut.replace(/^(\d)(\d{0,2})$/, '$1.$2');
                    }
                    return formatted_rut;
            },

            getPassData(e) {
                e.preventDefault();
                if (!this.pass_rut) {
                    this.rut_message = 'Debe completar este campo';
                } else {
                    let customer_rut = this.formatRut(this.pass_rut);
                    this.callPassData(customer_rut).then(data => {
                        if (this.isObjectEmpty(data)) {
                            this.rut_message = 'No se encuentra cliente con ese documento';
                        } else {
                            this.rut_message = 'Cliente encontrado';
                            this.names = data.first_name;
                            this.last_names = data.last_name;
                            this.email = data.email;
                            this.telephone = data.phone;
                            this.document_number = data.rut;
                            this.toggleForm = true;
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }
            },
            async callPassData(rut) {
                const config = {
                    params: {
                        rut: rut
                    }
                };
                return axios.get('/passes/pass/customer/', config)
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (error) {
                        return {};
                    });
            },
            async callTicketData(orderId) {
                return axios.get(`/store/orders/${orderId}/`)
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (error) {
                        return {};
                    });
            },
            async getOthersData() {
                let today = new Date();
                let tomorrow = new Date();
                let afterTomorrow = new Date();
                let afterAfterTomorrow = new Date();
                tomorrow.setDate(today.getDate() + 1);
                afterTomorrow.setDate(today.getDate() + 2);
                afterAfterTomorrow.setDate(today.getDate() + 3);

                let dates_str = [
                    moment(tomorrow).format('YYYY-MM-DD'),
                    moment(afterTomorrow).format('YYYY-MM-DD'),
                    moment(afterAfterTomorrow).format('YYYY-MM-DD'),
                ];
                await this.callMultipleStockData(dates_str).then(data => {
                    let index = 0;
                    data.forEach(stock => {
                        if (!stock.is_current_general_stock) {
                            this.boolOtherDates[index] = true;
                        }
                        index += 1
                    });
                    return this.boolOtherDates;
                }).catch(error => {
                    console.log(error);
                });
                return this.boolOtherDates;
            },
            async callMultipleStockData(dates) {
                let dates_str = dates.join(',');
                const config = {
                    params: {
                        dates: dates_str
                    }
                };
                return axios.get('/store/stocks/', config)
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (error) {
                        return {};
                    });
            },
            getDaysArray(start, end) {
                for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
                    arr.push(new Date(dt));
                }
                return arr;
            },
            prepareCalendar(flag_today = false, flag_tomorrow = false, flag_afterTomorrow = false,
            flag_afterAfterTomorrow = false, isFixTicket = false, fixDates = null) {
                let today = new Date();
                let yesterday = new Date();
                let tomorrow = new Date();
                let afterTomorrow = new Date();
                let afterAfterTomorrow = new Date();
                let dates = [];
                yesterday.setDate(today.getDate() - 1);
                tomorrow.setDate(today.getDate() + 1);
                afterTomorrow.setDate(today.getDate() + 2);
                afterAfterTomorrow.setDate(today.getDate() + 3);
                if (isFixTicket) {
                    if (fixDates.length == 1) {
                        let firstDay = new Date(fixDates[0].valueOf());
                        let lastDay = new Date(fixDates[0].valueOf());
                        firstDay.setDate(fixDates[0].getDate() - 1);
                        this.disabledDates = {
                            to: firstDay,
                            from: lastDay
                        };
                    } else {
                        let firstDay = new Date(fixDates[0]);
                        let lastDay = new Date(fixDates[fixDates.length - 1]);
                        // Create list of dates
                        let commonDates = this.getDaysArray(firstDay, lastDay);
                        // Remove date if equal to one date in list
                        let disabledDates = [];
                        commonDates.forEach(item => {
                            let notFound = true;
                            fixDates.forEach(fixDate => {
                                if (item.getTime() == fixDate.getTime()) {
                                    notFound = false;
                                }
                            });
                            if (notFound) {
                                disabledDates.push(item);
                            }
                        });
                        firstDay.setDate(fixDates[0].getDate() - 1);
                        this.disabledDates = {
                            to: firstDay,
                            from: lastDay,
                            dates: disabledDates
                        };
                    }
                } else {
                    if (flag_today) {
                        dates.push(today);
                    }
                    if (flag_tomorrow) {
                        dates.push(tomorrow);
                    }
                    if (flag_afterTomorrow) {
                        dates.push(afterTomorrow);
                    }
                    if (flag_afterAfterTomorrow) {
                        dates.push(afterAfterTomorrow);
                    }
                    this.disabledDates = {
                        to: yesterday,
                        from: afterAfterTomorrow,
                        dates: dates,
                    };
                }
            },
            beforeCloseModal(event) {
                this.resetForm();
            },
            validateInput(input, value) {
                if (!value) {
                    this.msg[input] = 'Debe llenar el campo';
                } else {
                    this.msg[input] = '';
                }
            }
        },
        watch: {
            date_attendance(value) {
                this.date_attendance = value;
                this.validateInput('date_attendance', value);
            },
            names(value) {
                this.names = value;
                this.validateInput('names', value);
            },
            last_names(value) {
                this.last_names = value;
                this.validateInput('last_names', value);
            },
            document_number(value) {
                this.document_number = value;
                this.validateInput('document_number', value);
            },
            telephone(value) {
                this.telephone = value;
                this.validateInput('telephone', value);
            },
            email(value) {
                this.email = value;
                this.validateInput('email', value);
            },
            symptom_check(value) {
                this.symptom_check = value;
                this.validateInput('symptom_check', value);
            },
            contact_check(value) {
                this.contact_check = value;
                this.validateInput('contact_check', value);
            },
            commune_check(value) {
                this.commune_check = value;
                this.validateInput('commune_check', value);
            },
            attest_check(value) {
                this.attest_check = value;
                this.validateInput('attest_check', value);
            },
        },
        computed: {
            ticketValidation: function () {
                return {
                    'health-ticket-error': this.ticket_message != '' && this.ticket_message !== 'Orden encontrada'
                }
            },
            passValidation: function () {
                return {
                    'health-pass-error': this.rut_message != '' && this.rut_message !== 'Cliente encontrado',
                    'health-pass-success':this.rut_message === 'Cliente encontrado'
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Pages/HealthPage.vue